import { Navigate } from "react-router";
import { useCompanyPath } from "@/hooks/useCompanyPath";

type CompanyNavigateProps = {
  to: string;
  replace?: boolean;
  state?: unknown;
};

export const CompanyNavigate = ({
  to,
  replace,
  state,
}: CompanyNavigateProps) => {
  const { buildPath } = useCompanyPath();
  return <Navigate to={buildPath(to)} replace={replace} state={state} />;
};
